import React from "react";
import {
  Card,
  CardContent,
  Chip,
  Grid,
  Typography,
  Button,
} from "@mui/material";
import {
  formatCurrency,
  formatDate,
  getJournalStatusDisplay,
} from "../utils/accountsHelpers";

const JournalList = ({ journals = [], onView }) => {
  if (!journals.length)
    return <Typography color="text.secondary">No journals found.</Typography>;

  return (
    <Grid container spacing={2}>
      {journals.map((journal) => {
        const status = getJournalStatusDisplay(journal.status);
        return (
          <Grid item xs={12} md={6} lg={4} key={journal.id}>
            <Card>
              <CardContent>
                <Typography variant="h6">{journal.journalNumber}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {journal.journalType} • {formatDate(journal.transactionDate)}
                </Typography>
                <Chip
                  sx={{ my: 1 }}
                  label={status.label}
                  color={status.color}
                  size="small"
                />
                <Typography variant="body2">
                  {journal.narration || "-"}
                </Typography>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Dr: {formatCurrency(journal.totals?.totalDebit || 0)}
                </Typography>
                <Typography variant="body2">
                  Cr: {formatCurrency(journal.totals?.totalCredit || 0)}
                </Typography>
                <Button
                  sx={{ mt: 2 }}
                  size="small"
                  variant="outlined"
                  onClick={() => onView?.(journal)}
                >
                  View Lines
                </Button>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default JournalList;
